export const allconfig = {
    env: process.env.REACT_APP_ENV,
    dev_api_url : process.env.REACT_APP_DEV_API_URL,
    dev_site_url: process.env.REACT_APP_DEV_SITE_URL,
    prod_api_url : process.env.REACT_APP_PROD_API_URL,
    prod_site_url: process.env.REACT_APP_PROD_SITE_URL,
    prod_landing_url: process.env.REACT_APP_PROD_LANDING_URL,
    gcs_bucket_name: process.env.REACT_APP_GCS_BUCKET_NAME
}

// Helper function to generate GCS image URL
export const generateImageUrl = (centerNumber, studentNumber, imageType = 'pictures', timestamp = null) => {
    if (!centerNumber || !studentNumber) {
        return ''
    }
    const bucketName = allconfig.gcs_bucket_name || 'your-bucket-name'
    const baseUrl = `https://storage.googleapis.com/${bucketName}/IJMB/students/${centerNumber}/${imageType}/${studentNumber}.webp`
    return timestamp ? `${baseUrl}?v=${timestamp}` : baseUrl
}